import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { DomainDetails } from './pages/DomainDetails';
import { MattDanilowiczBio } from './pages/MattDanilowiczBio';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="min-h-screen bg-navy text-offwhite font-sans selection:bg-amber selection:text-navy" data-id="element-1">
        <Navigation data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<Home data-id="element-5" />} data-id="element-4" />
          <Route path="/domain-focus" element={<DomainDetails data-id="element-7" />} data-id="element-6" />
          <Route path="/people/matt-danilowicz" element={<MattDanilowiczBio data-id="element-9" />} data-id="element-8" />
        </Routes>
        <Footer data-id="element-10" />
      </div>
    </BrowserRouter>;
}